module.exports = __webpack_public_path__ + "static/media/RulesforRuleBreakingBookJacket.259daf16.jpg";